// has to be string liter instead of general string
export interface TagTypeProps {
  USER: "USER";
  TODO: "TODO";
  GETCROP: "GETCROP";
  CROP: "CROP";
  YIELD: "YIELD";
  PREDICT: "PREDICT";
}

export const TAG_TYPE: TagTypeProps = {
  USER: "USER",
  TODO: "TODO",
  GETCROP: "GETCROP",
  CROP: "CROP",
  YIELD: "YIELD",
  PREDICT: "PREDICT",
};
